<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="aboutRect">
      <div class="about">
        1.您可以提前预约14-60天的行程，当满足开班最低人数需求后，我们将会尽力满足开班需求;<br>
        2.如开队失败，将会退回全部预交费用;<br>
        3.如没有符合要求的城市和队伍，可以自行创建并邀请朋友一同出行。<br>
      </div>
    </div>
    <div class="inputRect">
      <van-field
        v-model="reserveProductStr"
        required
        clearable
        label="行程"
        placeholder="选择行程"
        readonly
        @click="onCourse"
      />

      <template v-if="selectProduct">
        <van-field
          v-model="selectProduct.maxPerson"
          label="最大成员数"
          readonly
        />
        <van-field
          v-model="selectProduct.minPerson"
          label="最少成员数"
          readonly
        />
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>可选时间</span></div>
          <div>
            {{ selectProduct.memberCardReserveFinishDay }} 至 {{ selectProduct.memberCardReserveOpenDay }} 天后行程
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>预缴费用</span></div>
          <div :style="'color: '+GetColorMain()">
            CNY {{ ShowMoney(selectProduct.priceOne) }}
          </div>
        </div>
        <van-field
          v-model="selectProduct.reamrk"
          label="备注"
          readonly
        />
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>说明</span></div>
          <div v-html="selectProduct.about" />
        </div>
        <van-field
          v-model="startDateStr"
          required
          clearable
          label="出行日期"
          placeholder="选择出行日期"
          readonly
          @click="showDatePicker =true"
        />
      </template>

      <van-button type="primary" class="button" :disabled="!formData.reserveProductId || !formData.startDate" :loading="buttonLoading" :color="GetColorMainBack()" @click="onCreate">创建待组队行程</van-button>
    </div>
    <van-popup v-model="showCoursePicker" position="bottom">
      <van-picker
        title="选择行程"
        show-toolbar
        :columns="productColumns"
        @cancel="showCoursePicker = false"
        @confirm="onProductConfirm"
      />
    </van-popup>
    <van-calendar v-model="showDatePicker" :color="GetColorMainBack()" :formatter="formatterDate" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmDate" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Calendar, Picker, Popup } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '创建待组队行程',
      backurl: '/my/index',
      reserveProductStr: undefined,
      startDateStr: undefined,
      showCoursePicker: false,
      showDatePicker: false,
      buttonLoading: false,
      productList: [],
      productColumns: [],
      selectProduct: undefined,
      minDate: new Date(),
      maxDate: new Date(),
      formData: {
        hashCode: undefined,
        cardItemId: undefined,
        reserveProductId: undefined,
        startDate: undefined
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.formData.cardItemId = getUrlKey('itemId')
    this.formData.hashCode = getUrlKey('hashCode')
    this.initReserverList()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initReserverList() {
      request({
        url: '/MemberCard/getMemberCardReserveProductList',
        method: 'post',
        params: { id: this.formData.cardItemId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.productList = response.data
        this.productColumns = []
        this.productList.forEach(city => {
          var data = {
            text: city.cityName,
            children: []
          }
          city.list.forEach(el => {
            el.dates.forEach(dt => {
              if (dt.dateBegin) {
                dt.dateBegin = new Date(dt.dateBegin)
              }
              if (dt.dateEnd) {
                dt.dateEnd = new Date(dt.dateEnd)
              }
            })
            data.children.push({
              text: el.className,
              value: el.reserveProductId
            })
          })
          this.productColumns.push(data)
        })
        console.log('this.productList', this.productList)
      })
    },
    onCourse() {
      if (this.productList.length <= 0) {
        MyNotify('info', '无可用课程或加载中,请稍后再试')
        return
      }
      this.showCoursePicker = true
    },
    onProductConfirm(picker, values) {
      this.reserveProductStr = undefined
      this.formData.reserveProductId = undefined
      this.selectProduct = undefined
      this.showCoursePicker = false
      console.log('picker', picker)
      console.log('values', values)
      this.selectProduct = this.productList[values[0]].list[values[1]]
      console.log('selectProduct', this.selectProduct)
      if (this.selectProduct) {
        this.reserveProductStr = this.selectProduct.cityName + ' ' + this.selectProduct.className
        this.formData.reserveProductId = this.selectProduct.reserveProductId
        var date = new Date()
        this.minDate = new Date(date.setDate(date.getDate() + this.selectProduct.memberCardReserveFinishDay))
        var datee = new Date()
        this.maxDate = new Date(datee.setDate(datee.getDate() + this.selectProduct.memberCardReserveOpenDay))
      }
    },
    formatterDate(day) {
      if (!this.selectProduct || !this.selectProduct.dates || this.selectProduct.dates.length <= 0) {
        return day
      }
      var isDisable = false
      this.selectProduct.dates.forEach(el => {
        if (el.dateBegin && el.dateEnd) {
          if (el.dateBegin.getTime() <= day.date.getTime() && day.date.getTime() <= el.dateEnd.getTime()) {
            isDisable = true
          }
        } else if (el.dateBegin) {
          if (el.dateBegin.getTime() <= day.date.getTime()) {
            isDisable = true
          }
        } else if (el.dateEnd) {
          if (day.date.getTime() <= el.dateEnd.getTime()) {
            isDisable = true
          }
        }
      })
      if (isDisable) {
        day.type = 'disabled'
        day.bottomInfo = '不可用'
      } else {
        day.bottomInfo = ''
      }
      return day
    },
    onConfirmDate(date) {
      console.log('onConfirmDate', date)
      if (date < new Date()) {
        MyNotify('info', '请选择一个出行日期')
        return
      }
      this.formData.startDate = formatDate(date, 'yyyy/MM/dd')
      this.startDateStr = formatDate(date, 'yyyy/MM/dd')
      this.showDatePicker = false
    },
    onCreate() {
      this.buttonLoading = true
      request({
        url: '/MemberCard/MemberCardReserverCreate',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        console.log('onCreate PayId:' + response.data)
        MyNotify('success', '待组队行程创建成功!')
        this.$router.push('/store/pay/0?id=' + response.data)
      })
    }
  }
}
</script>
<style scoped>
.aboutRect{
  margin: 1em;
  padding: 1em;
  background-color: #fff;
  border-radius: 0.4em;
}
.aboutRect .about{
  font-size: 0.8em;
  line-height: 1.8em;
}
.inputRect{
  margin: 1em;

  background-color: #fff;
  border-radius: 0.4em;
  overflow: hidden;
}
.inputRect .button{
  width: 100%;
}
</style>
